<header *ngIf="!commonService.getViewMode()" class="headerMargin">
  <app-header></app-header>
</header>
<header *ngIf="commonService.getViewMode()">
  <app-header-lite></app-header-lite>
</header>
<main class="hm-gradient full-bg-img">
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!commonService.getViewMode()"></app-footer>
